export default {
      id: "ok-usage",
      viewBox: "0 0 15 14",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#ok",
      toString: function () {
        return this.url;
      }
    }